import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  captchaText: string = '';

  constructor() {}

  // Method to generate random CAPTCHA text
  generateCaptcha(): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    this.captchaText = Array.from({ length: 6 })
      .map(() => characters.charAt(Math.floor(Math.random() * characters.length)))
      .join('');
    return this.captchaText;
  }

  // Method to play CAPTCHA audio
  playCaptchaAudio(): void {
    const captchaText = this.captchaText;

    for (let i = 0; i < captchaText.length; i++) {
      const char = captchaText[i];
      let utteranceText = '';
      if (/[A-Z]/.test(char)) {
        utteranceText = `capital ${char}`;
      } else if (/[a-z]/.test(char)) {
        utteranceText = `small ${char}`;
      } else if (/\d/.test(char)) {
        utteranceText = char; // Just pronounce the number as is (e.g., "1")
      } else {
        utteranceText = char; // For any other special characters, just pronounce the character itself
      }

      const utterance = new SpeechSynthesisUtterance(utteranceText);
      utterance.lang = 'en-US';
      window.speechSynthesis.speak(utterance);
    }
  }
}